// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TTkC_","footer":"styles_footer__1J6Cv"};